module.exports = __webpack_public_path__ + "static/media/anetwork2.86935e08.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/article/anetwork2.png
// module id = 374
// module chunks = 0